import { mapGetters } from 'vuex'
import Utils from '@/services/utils'

export const Workspace = {
  data: () => ({
    headerTitleDefault: 'Collection Overview'
  }),

  computed: {
    ...mapGetters([
      'getGroupById',
      'getGroups',
      'getProjectsByGroupIdAndSeasonId',
      'getSeasonById',
      'getSeasons',
      'getSelectedGroupId',
      'getSelectedSeasonId',
      'getUser'
    ]),

    /**
     * @returns {object}
     */
    projects () {
      return this.getProjectsByGroupIdAndSeasonId(
        this.selectedGroupId,
        this.selectedSeasonId
      )
    },

    /**
     * @returns {object}
     */
    groups () {
      return this.getGroups
    },

    /**
     * @returns {object}
     */
    seasons () {
      return this.getSeasons()
    },

    /**
     * @returns {object}
     */
    selectedGroupId () {
      return this.getSelectedGroupId()
    },

    /**
     * @returns {object}
     */
    selectedSeasonId () {
      return this.getSelectedSeasonId()
    },

    /**
     * @returns {object}
     */
    selectedGroup () {
      return this.getGroupById(this.selectedGroupId)
    },

    /**
     * @returns {object}
     */
    selectedSeason () {
      return this.getSeasonById(this.selectedSeasonId)
    },

    /**
     * @returns {object}
     */
    user () {
      return this.getUser()
    },

    /**
     * @returns {string}
     */
    headerTitle () {
      if (this.selectedGroup && this.selectedSeason) {
        const titleDisplayName = this.selectedGroup.display_name
        const titleName = Utils.formatGroupName(this.selectedGroup.name)

        return `${titleDisplayName || titleName}/${this.selectedSeason.name}`
      } else {
        return this.headerTitleDefault
      }
    }
  }
}
